import { Theme } from "@mui/material";
import { SxProps } from "@mui/system";

const recommendationBoxStyle: SxProps<Theme> = (theme) => ({
  margin: "1rem 0",
  border: `2px solid ${theme.palette.primary.main}`,
  borderRadius: "0.5rem",
  padding: "1rem",
});

export default recommendationBoxStyle;
